const property = {
  property: {
      disclaimer: {
        heading: 'إخلاء المسؤولية ومعلومات الإعلان',
        reference: 'الرقم المرجعي: {{ref}}',
        advertiserFallback: 'المعلن',
        body:
          'المعلومات الواردة في هذه الصفحة هي إعلان عقاري مُقدَّم ومُحدَّث من قِبل المعلن ({{advertiser}}). لا تضمن صفقات 24 دقة أو اكتمال هذا الإعلان أو أي معلومات مرتبطة به، ولا تتحكم في محتواه، وهو لا يُعدّ عرضًا أو عقدًا أو بيانات عقارية رسمية. يُرجى التواصل مع المعلن مباشرةً للتحقق من أي تفاصيل - بما في ذلك الترخيص الإعلاني للعقار وأي مستندات متاحة بموجب الأنظمة العقارية السعودية - قبل اتخاذ أي إجراء أو سداد أي مبلغ.',
        rega:
          'يجب أن تحمل الإعلانات العقارية في المملكة العربية السعودية ترخيصًا إعلانيًا ساريًا صادرًا عبر الهيئة العامة للعقار (REGA).',
        adLicense: 'رقم الترخيص الإعلاني: {{number}}',
        linksLabel: 'اطّلع على',
        termsLink: 'شروط الاستخدام',
        falLink: 'إخلاء مسؤولية فال',
        footnoteData:
          'أوقات التنقل والأماكن القريبة وبيانات الحي وأي أرقام سوقية معروضة هي إرشادية فقط، وتستند إلى مصادر خارجية (منها Google)، وقد تتغير. تحقَّق منها بشكل مستقل قبل الاعتماد عليها.',
        footnoteMap: 'بيانات الخريطة © Google.',
        safety: {
          title: 'ابقَ آمنًا أثناء البحث عن عقار',
          body:
            'لا تُحوِّل أي مبلغ أو تُوقِّع أي مستند قبل التحقق من العقار والمعلن والترخيص الإعلاني على أرض الواقع. وإذا لاحظت ما يثير الشك، فأبلغ عن الإعلان.',
          report: 'الإبلاغ عن هذا الإعلان',
        },
      },
      loading: {
        title: 'جارٍ تحميل تفاصيل العقار...',
      },
      empty: {
        title: 'العقار غير متوفر',
        description: 'العقار الذي تبحث عنه أزيل أو أنه غير متاح مؤقتًا.',
        cta: 'تصفح القوائم',
      },
      header: {
        back: 'عودة إلى النتائج',
        save: 'حفظ',
        share: 'مشاركة',
        pricePerSqm: '{{value}} {{currency}} لكل {{unit}}',
        reviewsLink: '({{count}} تقييم للسكان)',
        reviewsLink_few: '({{count}} تقييمات للسكان)',
        areaScoreLabel: 'تقييم المنطقة',
        // تحت السعر السنوي: «يعادل ⃁ 7,500 في الشهر».
        monthlyLead: 'يعادل',
        monthlyTail: 'في الشهر',
        monthlyAccessible: 'يعادل {{value}} ريال سعودي في الشهر',
        listedOn: 'أُضيف في {{date}}',
        views: '{{formatted}} مشاهدة',
        views_zero: 'لا مشاهدات',
        views_one: 'مشاهدة واحدة',
        views_two: 'مشاهدتان',
        views_few: '{{formatted}} مشاهدات',
        views_many: '{{formatted}} مشاهدة',
        views_other: '{{formatted}} مشاهدة',
      },
      badges: {
        hot: 'الأكثر طلباً',
        mostLiked: 'الأكثر إعجاباً',
        mostViewed: 'الأكثر مشاهدة',
        new: 'جديد',
        featured: 'مميز',
      },
      gallery: {
        photoCount: '{{count}} صورة',
        photoCount_few: '{{count}} صور',
        virtualTour: 'جولة افتراضية',
        tabs: { images: 'الصور', videos: 'فيديو', floorPlan: 'المخطط', virtualTour: 'جولة افتراضية' },
        videoUnavailable: 'الفيديو غير متاح',
        tourComingSoon: 'الجولة الافتراضية قريباً',
        markFloorPlan: 'تعيين كمخطط',
        isFloorPlan: 'مخطط',
        videoLinkLabel: 'رابط الفيديو',
        videoLinkPlaceholder: 'https://youtube.com/...',
      },
      status: {
        available: 'متاح',
        pending: 'تحت التفاوض',
        sold: 'مباع',
        rented: 'مؤجر',
      },
      metrics: {
        bedrooms: {
          label: 'غرف النوم',
          subtitle: '{{formatted}} غرفة نوم',
          subtitle_other: '{{formatted}} غرف نوم',
        },
        bathrooms: {
          label: 'دورات المياه',
          subtitle: '{{formatted}} دورة مياه',
          subtitle_other: '{{formatted}} دورات مياه',
        },
        area: {
          label: 'المساحة الإجمالية',
          subtitle: '{{value}} {{unit}}',
        },
        yearBuilt: {
          label: 'سنة البناء',
          subtitle: '{{value}}',
        },
      },
      sections: {
        details: 'تفاصيل العقار',
        description: 'الوصف',
        features: 'المزايا والمرافق',
        propertyFeatures: 'مزايا العقار',
        amenities: 'المرافق',
        utilities: 'الخدمات المشمولة',
        location: 'الموقع',
        contact: 'تواصل مع الوسيط',
        info: 'معلومات العقار',
      },
      propertyFeatures: {
        parking: 'موقف سيارات',
        petFriendly: 'مسموح بالحيوانات الأليفة',
        furnished: 'مفروشة',
        coveredParking: 'موقف سيارات مظلل',
        coveredParking_one: 'موقف مظلل لسيارة واحدة',
        coveredParking_two: 'موقف مظلل لسيارتين',
        coveredParking_few: 'موقف مظلل لـ {{count}} سيارات',
        coveredParking_many: 'موقف مظلل لـ {{count}} سيارة',
        coveredParking_other: 'موقف مظلل لـ {{count}} سيارة',
      },
      utilities: {
        title: 'الخدمات المشمولة',
      },
      location: {
        fullAddress: '{{address}}، {{city}}، {{state}} {{zip}}',
        openMaps: 'عرض على خرائط جوجل',
      },
      contact: {
        agentTitle: 'وسيط معتمد',
        scheduleButton: 'حجز معاينة',
        contactButton: 'تواصل مع الوسيط',
        sendEnquiry: 'إرسال استفسار',
        enquiryMessage: 'مرحباً، أنا مهتم بهذا العقار: {{title}}',
        scheduleMessage: 'تم استلام طلب المعاينة. سيتواصل معك فريقنا قريبًا.',
        verifiedAgent: 'وسيط معتمد',
        avgResponse: 'متوسط الرد: خلال ساعة ⏱',
        callNow: 'اتصل الآن',
        whatsapp: 'واتساب',
        requestDetails: 'طلب التفاصيل',
        authPrompt: {
          title: 'سجّل الدخول للتواصل مع المعلن',
          message: 'أنشئ حساباً مجانياً أو سجّل الدخول للاتصال أو المراسلة عبر واتساب أو البريد بخصوص هذا العقار.',
          signIn: 'تسجيل الدخول',
          cancel: 'إلغاء',
        },
      },
      neighborhood: {
        title: 'الحي',
        caption: 'استناداً إلى المرافق المذكورة في هذا الإعلان',
        captionNearby: 'استناداً إلى أماكن حقيقية قريبة من هذا العقار',
        empty: 'تفاصيل الحي غير متوفرة بعد',
        overall: 'تقييم المنطقة',
        // درجة الحي العامة (من مهمة التقييم الليلية لبيانات سوق الحي كاملاً) —
        // نطاق مختلف عن «الخدمات القريبة» المحسوبة حول هذا العقار تحديداً.
        districtScoreLabel: 'درجة الحي العامة',
        districtScoreCaption: 'من بيانات سوق الحي كاملاً - تُحدَّث يومياً',
        nearbyServicesTitle: 'الخدمات القريبة من العقار',
        // يفتح بقية معلومات الحي: تفاصيل الخدمات، بيانات الموقع، أسعار الصفقات والإيجار.
        showMore: 'عرض المزيد عن الحي',
        showLess: 'عرض أقل',
        factors: {
          schools: 'المدارس والتعليم',
          services: 'التسوق والخدمات',
          healthcare: 'الرعاية الصحية',
          transport: 'المواصلات والوصول',
          religious: 'المساجد',
        },
      },
      landmarks: {
        title: 'معالم قريبة',
        fromLabel: 'يبعد {{distance}} كم عن {{name}}',
        greatToVisit: 'وجهة مميزة للزيارة',
      },
      nearby: {
        title: 'الموقع والأماكن القريبة',
        openMap: 'فتح الخريطة',
        showAll: 'عرض الكل ({{count}} مكاناً)',
        showLess: 'عرض أقل',
      },
      travel: {
        title: 'كم يبعد عن وجهاتك اليومية؟',
        subtitle: 'أضف مكان عملك أو مدرسة أطفالك لمعرفة زمن الوصول إليه بالسيارة من هذا العقار.',
        placeholder: 'مثال: مكتبي في حي الروضة',
        add: 'أضف مكاناً',
        checking: 'جارٍ التحقق...',
        notFound: 'تعذّر العثور على هذا المكان - جرّب كتابة اسم أوضح أو أكثر تحديداً.',
        byCar: '~{{minutes}} د بالسيارة',
        byCarHours: '~{{hours}} س {{minutes}} د بالسيارة',
        remove: 'إزالة {{name}}',
        unavailable: 'زمن الوصول غير متوفر',
        savedToAccount: 'تم الحفظ في حسابك',
        savedLocally: 'تم الحفظ على هذا الجهاز - سجّل الدخول لحفظه في حسابك',
      },
      similar: {
        title: 'عقارات مشابهة',
        sameAgentTitle: 'عقارات مشابهة من نفس الوسيط',
        viewMore: 'عرض المزيد',
        rooms: '{{formatted}} غرف',
        rooms_one: 'غرفة واحدة',
        badges: {
          hot: 'الأكثر طلباً',
          featured: 'مميز',
          sameDistrict: 'نفس الحي',
          new: 'جديد',
        },
      },
      form: {
        namePlaceholder: 'اسمك',
        emailPlaceholder: 'البريد الإلكتروني',
        phonePlaceholder: 'رقم الهاتف',
        messagePlaceholder: 'تفاصيل إضافية (اختياري)',
        submit: 'إرسال الرسالة',
        replyTimeNote: 'سنتواصل معك خلال 1 إلى 5 أيام عمل.',
        successMessage: 'تم إرسال رسالتك. سنتواصل معك خلال 1 إلى 5 أيام عمل.',
      },
      info: {
        labels: {
          id: 'معرّف العقار',
          type: 'نوع العقار',
          yearBuilt: 'سنة البناء',
          status: 'الحالة',
          listed: 'تاريخ الإدراج',
          updated: 'آخر تحديث',
          adNumber: 'رقم الإعلان',
        },
      },
      properties: {
        'ksa-riyadh-01': {
          title: 'فيلا بانورامية مطلة على منتزه جدة',
          address: 'طريق الملك عبد الله',
          city: 'جدة',
          state: 'منطقة جدة',
          description:
            'فيلا من خمس غرف نوم بفراغات معيشة بارتفاع مزدوج، ونوافذ ممتدة من الأرض إلى السقف، وسينما خاصة، وتراسات خارجية منسقة تطل على منتزه جدة دون عوائق.',
          amenities: [
            'مسبح بحافة متلاشية مع كابانا',
            'صالة سينما خاصة',
            'أتمتة منزلية ذكية',
            'سطح خارجي بإطلالات على الأفق',
            'مطبخ احترافي للطهاة',
            'جناح عافية مخصص',
          ],
          utilities: ['الكهرباء', 'الماء', 'إنترنت عالي السرعة'],
          agentName: 'سارة آل سعود',
          agentTitle: 'مستشارة عقارية أولى',
        },
        'ksa-jeddah-02': {
          title: 'إقامة بحرية محاطة بالنخيل في جدة',
          address: 'طريق الكورنيش، أبحر الشمالية',
          city: 'جدة',
          state: 'منطقة مكة المكرمة',
          description:
            'شقة عصرية على الواجهة البحرية بإطلالات واسعة على البحر الأحمر، وتراسات فسيحة، وتصميمات داخلية منسقة تجمع بين أناقة المنتجعات وراحة المدينة.',
          amenities: [
            'وصول خاص إلى الشاطئ',
            'شرفة بإطلالة على المرسى',
            'سطح مسبح بطابع المنتجعات',
            'نادي لياقة للمقيمين',
            'خدمات كونسيرج في الموقع',
            'مواقف سيارات تحت الأرض مؤمّنة',
          ],
          utilities: ['الكهرباء', 'الماء', 'إنترنت عالي السرعة', 'تبريد مركزي'],
          agentName: 'محمد بوزير',
          agentTitle: 'اختصاصي التأجير الفاخر',
        },
        'ksa-dammam-03': {
          title: 'منزل عائلي عصري في مرتفعات الدمام',
          address: 'طريق الأمير نايف',
          city: 'الدمام',
          state: 'المنطقة الشرقية',
          description:
            'منزل تاون هاوس عصري بأربع غرف نوم مصمم بعناية للحياة العائلية، يجمع بين صالونات مزدوجة، وفناء منسق، ووصول سلس إلى مراكز الأعمال الجديدة في المنطقة.',
          amenities: [
            'حديقة عائلية داخلية',
            'مرآب خاص يتسع لسيارتين',
            'جناح مستقل للخادمة',
            'دخول إلى النادي الاجتماعي للمجتمع',
            'منطقة لعب قريبة للأطفال',
            'زجاج عالي الكفاءة في استهلاك الطاقة',
          ],
          utilities: ['الكهرباء', 'الماء', 'الغاز'],
          agentName: 'ليان المطيري',
          agentTitle: 'مستشارة سكنية',
        },
        'ksa-riyadh-04': {
          title: 'استوديو سماوي في حي مركز الملك عبدالله المالي',
          address: 'مركز الملك عبدالله المالي',
          city: 'جدة',
          state: 'منطقة جدة',
          description:
            'استوديو مرتفع بإطلالات بانورامية على المدينة، وتشطيبات مصممة بعناية، وإمكانية وصول سلسة إلى مطاعم وتسوق وأعمال KAFD.',
          amenities: [
            'استوديو لياقة بإطلالة بانورامية',
            'صالة وإمكانات عمل مشتركة للمقيمين',
            'خدمات كونسيرج على مدار الساعة',
            'حديقة سماوية',
            'موقف سيارة مؤمّن',
            'حلول تخزين مدمجة',
          ],
          utilities: ['الكهرباء', 'الماء', 'إنترنت عالي السرعة'],
          agentName: 'أحمد الدوسري',
          agentTitle: 'مستشار تأجير حضري',
        },
      },
  },
};

export default property;
